<template>
  <v-container
    fluid
  >
    <base-material-card
      inline
      icon="mdi-map-marker"
      title="Sites"
    >
      <data-table
        :fetch-from="fetchForm"
        :fields="fields"
      >
        <template
          slot="actions"
          slot-scope="slotData"
        >
          <v-btn
            x-small
            color="primary"
            @click="showDetails(slotData.rowData.id)"
          >Show</v-btn>
        </template>

        <template
          slot="site_sharing"
          slot-scope="slotData"
        >
          {{ slotData.rowData.location.site_sharing|formatBool|noDataAvailable }}
        </template>

        <template
          slot="active_candidate"
          slot-scope="slotData"
        >
          {{ slotData.rowData.active_candidate|formatBool|noDataAvailable }}
        </template>

      </data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import SitesService from '@/services/sites'
  import DataTable from '@/components/DataTable'

  export default {
    name: 'Index',
    components: { DataTable },
    data: function () {
      return {
        fields: [
          {
            name: 'site_id',
            title: 'Site id',
          },
          {
            name: 'status',
            title: 'Status',
          },
          {
            name: 'site_name',
            title: 'Site name',
          },
          {
            name: 'type',
            title: 'Type',
          },
          {
            name: '__slot:active_candidate',
            title: 'Active candidate',
          },
          {
            name: 'municipality',
            title: 'Municipality',
          },
          {
            name: '__slot:site_sharing',
            title: 'Site sharing',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ],
      }
    },
    methods: {
      fetchForm (urls, options) {
        const ns = new SitesService()
        return ns.list(options.params)
      },
      showDetails (id) {
        this.$router.push({ path: `/sites/${id}/view` })
      },
    },
  }
</script>

<style scoped>

</style>
